import { StatGroup } from '../services/viva/constants';

export const compareStatGroups = (
  statGroup1: string[] | StatGroup,
  statGroup2: string[] | StatGroup,
) => [...statGroup1].sort().toString() === [...statGroup2].sort().toString();

const ignoreTheseStatGroups = [StatGroup.SUNSET, 'WEBRINK', 'CHALET'];
export const getRelevantStatGroup = (
  _statGroup: StatGroup | StatGroup[] | string[],
) => {
  const statGroup = Array.isArray(_statGroup) ? _statGroup : [_statGroup];

  return statGroup.filter(
    (i) => i && !ignoreTheseStatGroups.includes(i.replace(/[^\w0-9_-]/g, '')),
  )[0] as StatGroup;
};
